import { UNSUBSCIBED_EMAIL } from "../api";
import axiosInstance from "../axiosInstance";

export const unsubscribedEmail = (props) => onResponse => {
    try {
        axiosInstance.post(UNSUBSCIBED_EMAIL, props)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err?.response?.data);
            });

    } catch (error) {

    }
}